"use client";

import { lazy, Suspense } from "react";
import { CarouselSkeleton } from "./skeletons";

// Lazy load the heavy carousel component
const CarouselSection = lazy(() => import("./CarouselSection"));

export default function LazyCarouselSection(props) {
  return (
    <Suspense
      fallback={
        <CarouselSkeleton title={props.title} description={props.description} />
      }
    >
      <CarouselSection {...props} />
    </Suspense>
  );
}
